import { NavLink } from "react-router-dom";
import { Home, Ticket, User } from "lucide-react";
import { cn } from "@/lib/utils";
import { APP_NAV } from "@/constants/testIds";

const items = [
  { to: "/app", label: "Inicio", icon: Home, testId: APP_NAV.inicio, end: true },
  { to: "/app/mis-boletos", label: "Mis Boletos", icon: Ticket, testId: APP_NAV.misBoletos },
  { to: "/app/mi-perfil", label: "Mi Perfil", icon: User, testId: APP_NAV.miPerfil },
];

/**
 * Fixed bottom navigation. Exactly 3 items · immutable per spec.
 */
export default function BottomNav() {
  return (
    <nav
      aria-label="Navegación principal"
      className={cn(
        "fixed bottom-0 inset-x-0 z-50",
        "glass border-t hairline",
        "pb-safe",
      )}
      data-testid="app-bottom-nav"
    >
      <ul className="max-w-2xl mx-auto grid grid-cols-3 px-4 pt-2">
        {items.map(({ to, label, icon: Icon, testId, end }) => (
          <li key={to}>
            <NavLink
              to={to}
              end={end}
              data-testid={testId}
              className={({ isActive }) =>
                cn(
                  "group flex flex-col items-center justify-center gap-1 py-2",
                  "text-[11px] font-medium tracking-wide",
                  "transition-colors duration-200",
                  isActive
                    ? "text-primary dark:text-accent"
                    : "text-muted-foreground hover:text-foreground",
                )
              }
            >
              {({ isActive }) => (
                <>
                  <span
                    className={cn(
                      "grid place-items-center w-10 h-10 rounded-full",
                      "transition-all duration-300",
                      isActive
                        ? "bg-primary/10 dark:bg-accent/15 ring-1 ring-primary/20 dark:ring-accent/30"
                        : "group-hover:bg-muted",
                    )}
                  >
                    <Icon
                      className="w-[18px] h-[18px]"
                      strokeWidth={isActive ? 2 : 1.6}
                    />
                  </span>
                  <span>{label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
